module.exports = __webpack_public_path__ + "images/f53dfcf67b954af7389bb7d44278620c-IMG_6052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_6052.jpg
// module id = ./src/assets/images/slides/living/IMG_6052.jpg
// module chunks = 0